import React from 'react'
import styles from './Container.module.sass'

export default function Container({ size = '', children }) {
    return (
        <div className={`${styles.root} ${size ? styles[`root--${size}`] : ''}`} >
            {children}
        </div>
    )
}
